import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown, Menu } from "lucide-react";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../lib/LanguageContext";
import { WorkspaceNav } from "./WorkspaceNav";
export const MobileSectionsMenu = () => {
    const { t } = useLanguage();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const currentSection = (() => {
        if (location.pathname.startsWith("/settings"))
            return t("nav.settings");
        if (location.pathname.startsWith("/strategies"))
            return t("nav.strategies");
        if (location.pathname.startsWith("/orders"))
            return t("nav.orders");
        if (location.pathname.startsWith("/analytics"))
            return t("nav.analytics");
        if (location.pathname.startsWith("/reports"))
            return t("nav.pnlReport");
        if (location.pathname.startsWith("/journal"))
            return t("nav.journal");
        if (location.pathname.startsWith("/admin"))
            return t("nav.admin");
        return t("nav.dashboard");
    })();
    return (_jsxs("div", { className: "mb-4 lg:hidden", children: [_jsxs("button", { type: "button", className: "flex w-full items-center justify-between rounded-lg border border-border bg-card px-3 py-2 text-sm font-medium text-foreground", onClick: () => setOpen((prev) => !prev), "aria-expanded": open, children: [_jsxs("span", { className: "inline-flex items-center gap-2", children: [_jsx(Menu, { className: "h-4 w-4", "aria-hidden": true }), currentSection] }), _jsx(ChevronDown, { className: `h-4 w-4 transition ${open ? "rotate-180" : ""}`, "aria-hidden": true })] }), open ? (_jsx("div", { className: "mt-2 rounded-lg border border-border bg-card p-2", children: _jsx(WorkspaceNav, { onNavigate: () => setOpen(false) }) })) : null] }));
};
